import { useGet } from '@/query/fetchHooks';
import {
  Learningpathprogressdetails,
  Userwithorganisationwithidps,
} from '@/models';
import { EndUserCard, Card, Tag } from '@teo/components';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { ChapterFilled, TimeFilled } from '@teo/components/icons';
import clsx from 'clsx';

function ListOfCourses({
  props,
  progress,
  lable,
  courses,
  title,
  path,
  setDashboardCourses,
}: any) {
  const { t } = useTranslation();
  const basePath = window.location.pathname;
  const navigate = useNavigate();

  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  const [myCourses, setMyCourses] = useState<any[]>(courses);

  const { data, status } = useGet<Array<Learningpathprogressdetails>>(
    '/myoverview',
    {
      courseStatus: 'active',
      status: 'active',
      offset: '0',
      count: 3,
      userId: authUser?.id,
      ...props,
      enabled: !courses,
      onSuccess: (result: any) => {
        setMyCourses(result?.data);
        setDashboardCourses((prev: any) =>
          prev ? [...prev, ...(result?.data || [])] : [...(result?.data || [])]
        );
      },
    }
  );

  const coursePath = basePath.endsWith('/')
    ? basePath.slice(0, basePath.lastIndexOf('/'))
    : basePath;

  function convertToTime(number: number) {
    const hours = Math.floor(number / 3600);
    const minutes = Math.round((number / 3600 - hours) * 60);
    return (
      hours +
      `${t('pages.learn_index.hour')} ` +
      minutes +
      `${t('pages.learn_index.minute')} `
    );
  }

  return (
    <>
      {myCourses?.length > 0 && (
        <>
          <p className="text-md mt-6 font-semibold text-[#231f20]">{title}</p>
          <div className="mt-3 flex w-full flex-row flex-wrap gap-3 sm:flex-nowrap">
            {myCourses?.map((course: any) => {
              let typeCourse: string;
              switch (course?.courseType) {
                case 'instruction':
                  typeCourse = 'instructions';
                  break;
                case 'leervacature':
                  typeCourse = 'vacancies';
                  break;
                case 'assessment':
                  typeCourse = 'assessments';
                  break;
                case 'course':
                  typeCourse = 'courses';
                  break;
                default:
                  typeCourse = 'learning-paths';
                  break;
              }
              const defaultImg =
                course?.type === 'lpgroup'
                  ? '/assets/images/LearnPath.png'
                  : '/assets/images/opleidingen.jpg';
              return (
                <div
                  key={course.objectId}
                  className="relative max-w-[calc(50%_-_6px)] basis-1/2 sm:max-w-none sm:basis-1/3"
                >
                  <Card className="group">
                    <Link
                      className="text-grey-08"
                      to={`${coursePath}/${typeCourse}/${course?.objectId}`}
                    >
                      <div
                        className={clsx([
                          'relative mb-3 flex justify-center overflow-hidden rounded-lg bg-grey-02',
                        ])}
                      >
                        <img
                          alt="Course preview image"
                          src={course?.picture || defaultImg}
                          className="h-[140px] w-full rounded-lg object-cover transition-transform duration-500 group-hover:scale-105	"
                        />
                        {lable && (
                          <div className="absolute top-1 left-2 ">
                            <Tag title={lable} variant="primary" />
                          </div>
                        )}
                      </div>
                      {progress && (
                        <div className="mb-1 flex items-center">
                          <div className="h-1 w-full rounded-lg bg-grey-02">
                            <div
                              aria-label={`${progress}%`}
                              className="h-1 rounded-lg bg-secondary-04"
                              style={{
                                width: `${
                                  progress
                                    ? course.progress
                                      ? Math.round(course.progress * 100)
                                      : 0
                                    : 0
                                }%`,
                              }}
                            ></div>
                          </div>
                          <span className="ml-3 text-xs text-grey-06">
                            {progress
                              ? course.progress
                                ? Math.round(course.progress * 100)
                                : 0
                              : 0}
                            &#37;
                          </span>
                        </div>
                      )}
                      <Card.Title customStyles={'break-keep'} bottomMargin="xs">
                        {course?.courseName || course?.name || ''}
                      </Card.Title>

                      <div className="flex items-center gap-4">
                        <span className="text-sm text-grey-04">
                          <ChapterFilled className="inline h-4 w-4" />{' '}
                          {course?.nrOfItems ? course.nrOfItems : 0}
                        </span>
                        {course?.totalEstimatedTime && (
                          <span className="text-sm text-grey-04">
                            <TimeFilled className="inline h-4 w-4" />{' '}
                            {course?.totalEstimatedTime
                              ? convertToTime(
                                  Math.abs(course?.totalEstimatedTime)
                                )
                              : ''}
                          </span>
                        )}
                      </div>
                    </Link>
                  </Card>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

export default ListOfCourses;
